import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";


const FileInput = ({ field, setFieldValue, values }) => {

    const [fileURL, setFileURL] = useState(null);
    useEffect(() => {
        if (values[field.name]) {
          if (typeof values[field.name] === "string") {
            if (values[field.name].startsWith("http")) {
              setFileURL(values[field.name]);
            } else {
              setFileURL(`${process.env.REACT_APP_API_URL}${values[field.name]}`);
            }
          } else if (values[field.name] instanceof Blob) {
            setFileURL(URL.createObjectURL(values[field.name]));
          }
        }
      }, [values, field.name]);
    
      const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
          if (field.format === "base64") {
            const reader = new FileReader();
            reader.onloadend = () => setFieldValue(field.name, reader.result);
            reader.readAsDataURL(file);
          } else {
            setFieldValue(field.name, file);
          }
        }
      };

  const renderPreview = () => {
    if (!fileURL) {
      return (
        <div className='h-36 w-full flex flex-col items-center justify-center rounded-lg'>
          <span className="w-9 h-9 bg-gray-200 rounded-full flex justify-center items-center p-1.5 mt-4 mb-2">
            <GetIcon iconName="IoImageOutline" size={32} design="text-primary" />
          </span>
          <h1 className="mb-3 text-gray-500 font-inter">Drag and drop image here, or click to add</h1>
          <label htmlFor={field.name} className="px-4 py-2 bg-gray-200  text-primary rounded-lg cursor-pointer">
            Add {field.label}
          </label>
        </div>
      );
    }
    if (field.label === 'Video') {
      return <video src={fileURL} controls className='h-64 w-full mx-auto mb-2 rounded-lg' />;
    }
    return (
      <div className="relative">
        <img src={fileURL} alt={field.label} className='h-64 w-54 mx-auto rounded-lg object-fit' />
        <label htmlFor={field.name} className="absolute bottom-2 left-1/2 transform -translate-x-1/2 px-4 py-2 bg-lightgrey text-primary rounded-lg cursor-pointer">
          Add {field.label}
        </label>
      </div>
    );
  };

  return (
    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
      {renderPreview()}
      <input type="file" accept={field.label === "Video" ? "video/*" : "image/*"} className="hidden" id={field.name} onChange={handleFileChange} />
    </div>
  );
};

export default FileInput;